export default __webpack_public_path__ + "static/media/1511.e388c6a6.png";